import type { QueryKey } from '@tanstack/react-query';

import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import type { OrganizationDomain } from '../../../../shared/model-typings/organizationdomain';

function fetchOrganizationDomains(organizationId: number) {
  return get<OrganizationDomain[]>(`/api/organizations/${organizationId}/domains`);
}

export const getOrganizationDomainsQueryKey = (organizationId: number): QueryKey => [
  'organizations',
  organizationId,
  'domains',
];

/**
 * Hook to fetch SSO domains for an organization.
 * @param organizationId - The organization ID
 * @returns Query result containing the list of organization domains
 */
export const useOrganizationDomains = (organizationId: number) => {
  return useQuery<OrganizationDomain[]>({
    queryKey: getOrganizationDomainsQueryKey(organizationId),
    queryFn: () => fetchOrganizationDomains(organizationId),
    staleTime: 60_000, // Cache for 1 minute
  });
};
